import { View, Text } from "react-native";
import type { LucideIcon } from "lucide-react-native";
import { colors } from "../theme/tokens";

type Props = {
  children: string;
  icon?: LucideIcon;
  color?: string;
};

/**
 * Uppercase section title used across the app.
 * 12px / 600 weight / uppercase / textLight / letterSpacing 1.
 * Optional inline icon at 13px outline, same color, strokeWidth 1.75.
 */
export function SectionTitle({
  children,
  icon: Icon,
  color = colors.textLight,
}: Props) {
  const label = (
    <Text
      className="font-dm-sans"
      style={{
        fontSize: 12,
        fontWeight: "600",
        color,
        letterSpacing: 1,
        textTransform: "uppercase",
      }}
    >
      {children}
    </Text>
  );

  if (!Icon) return label;

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: 7,
      }}
    >
      <Icon size={13} color={color} strokeWidth={1.75} />
      {label}
    </View>
  );
}

export default SectionTitle;
